import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsMyFhe(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsMyFhe(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsMyFhe - ', e);
                throw e;
            });
    };
}
export { getLogsMyFhe };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsMyFhe/actions.js